import { Component, Input, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';

import { ApiError, MessageService } from '../../../../core';
import { ClienteCentralCompraHttpService } from './services';
import { ClienteCentralCompra } from './cliente-central-compra';

@Component({
    selector: 'sgt-cliente-central-compra',
    templateUrl: './cliente-central-compra.component.html',
    styleUrls: ['./cliente-central-compra.component.less']
})
export class ClienteCentralCompraComponent implements OnInit {
    /** ID da central de compras */
    @Input() idClienteCentralCompra: number;
    /** Se deve exibir os participantes */
    @Input() showParticipantes = true;

    centralCompras: ClienteCentralCompra;
    isLoading: boolean;
    isLoaded: boolean;

    constructor(private messageService: MessageService,
                private clienteCentralCompraHttpService: ClienteCentralCompraHttpService) { }

    ngOnInit() {
        this.load();
    }

    /** Carrega a central de compras */
    load() {
        if (!this.idClienteCentralCompra) {
            return;
        }

        this.isLoading = true;
        this.isLoaded = false;
        this.centralCompras = null;
        this.clienteCentralCompraHttpService.load(this.idClienteCentralCompra)
            .pipe(
                take(1)
            )
            .subscribe(
                centralCompras => {
                    this.centralCompras = centralCompras;
                    this.isLoading = false;
                    this.isLoaded = true;
                },
                (error: ApiError) => {
                    this.messageService.error(error.message, 'Erro ao carregar a central de compras', error);
                    this.isLoading = false;
                    this.isLoaded = false;
                }
            );
    }
}
